import styled from "styles/styled_components";

const StyledHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const StyledAction = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${props => props.theme.spacing.small};
`;

const StyledLeftAction = styled.div`
  margin-right: auto;
`;

export { StyledHeader, StyledAction, StyledLeftAction };
